import { render, staticRenderFns } from "./dangan.vue?vue&type=template&id=209aad2f"
import script from "./dangan.vue?vue&type=script&lang=js"
export * from "./dangan.vue?vue&type=script&lang=js"
import style0 from "./dangan.vue?vue&type=style&index=0&id=209aad2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports